import { useTableFilter } from '@welbe/web-design-system';
import { useState } from 'react';
import { getAccessManagement } from '../Users.services';
import { Admin } from './AdminDialog/AdminDialog.types';

export const useAdmin = () => {
	const [selectedUser, setSelectedUser] = useState<Admin>();
	const [isUserModalVisible, setUserModalVisible] = useState<boolean>(false);
	const [openModalAddProfile, setOpenModalAddProfile] =
		useState<boolean>(false);

	const {
		filters,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
	} = useTableFilter({
		service: getAccessManagement,
		instantSearch: ['status', 'pageSize', 'pageNumber'],
		tableFilters: {
			name: '',
			status: '',
			pageSize: 50,
			pageNumber: 0,
			type: 'admin',
		},
	});

	const handleEditUser = (userInfo: any) => {
		setSelectedUser(userInfo);
		setUserModalVisible(true);
	};

	const handleToggleUserModal = (open: boolean) => {
		if (!open) setSelectedUser(undefined);
		setUserModalVisible(open);
	};

	return {
		selectedUser,
		isUserModalVisible,
		setUserModalVisible,
		handleEditUser,
		handleToggleUserModal,
		openModalAddProfile,
		setOpenModalAddProfile,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
	};
};
